import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import Picture from '@cotyorg/ccx-atoms/Picture';
import { HeroFullCombined } from '@cotyorg/ccx-organism-hero';
import { VideoPlayer } from '@cotyorg/ccx-organism-video';
import {
  trackVideoMilestoneEvent,
  trackVideoPlayEvent,
} from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/video';
import StandardLayout from '../../templates/StandardLayout';
import { isLargeBreakpoint } from '../../utils';
import { ProductCollection } from './Sections/ProductCollections/ProductCollection';

const MadameWeb = ({
  images,
  numberOfHeroes,
  currentBreakpoint,
  productCollection,
  ctas,
  trailerDescription,
  videos,
}) => (
  <StandardLayout>
    <div className="madame-web">
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16">
            <div className="madame-web__banner">
              <Picture
                alt={R.path(['banner', 0, 'imageAlt'], images)}
                src={R.path(['banner', 0, 'imageSrc'], images)}
                srcset={R.path(['banner', 0, 'imageSrcSet'], images)}
              />
            </div>
          </div>
        </div>
        <div className="madame-web__contest">
          <HeroFullCombined heroStoreDataKey="contestHero" layout="vertical" />
        </div>
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16 visible">
            <div className="madame-web__heroSection">
              {[...Array(numberOfHeroes)].map((item, index) => {
                const isContentFirst =
                  index % 2 !== 0 && isLargeBreakpoint({ currentBreakpoint });

                return (
                  <HeroFullCombined
                    heroStoreDataKey={`hero${index + 1}`}
                    isContentFirst={isContentFirst}
                    isUnderlined={false}
                  />
                );
              })}
            </div>
          </div>
        </div>
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16">
            <p className="trailer_description">{trailerDescription}</p>
          </div>
        </div>
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16">
            <div className="madame-web__video">
              <VideoPlayer
                videosStoreDataKey="rimmelMadameWebVideo"
                showControls={false}
                config={{
                  youtube: {
                    playerVars: {
                      controls: 1,
                    },
                    embedOptions: {
                      host: 'https://www.youtube-nocookie.com',
                    },
                  },
                  file: {
                    attributes: {
                      controls: true,
                    },
                  },
                }}
                onProgress={({ url, duration, progress, videoMilestone }) =>
                  trackVideoMilestoneEvent({
                    url,
                    duration,
                    progress,
                    videoMilestone,
                    title: R.path(['rimmelMadameWebVideo', 'name'], videos),
                  })
                }
                onPlay={({ url, duration, progress }) =>
                  trackVideoPlayEvent({
                    url,
                    duration,
                    progress,
                    title: R.path(['rimmelMadameWebVideo', 'name'], videos),
                  })
                }
              />
            </div>
          </div>
        </div>
        <ProductCollection productCollection={productCollection} ctas={ctas} />
      </div>
    </div>
  </StandardLayout>
);

MadameWeb.propTypes = {
  images: PropTypes.objectOf(PropTypes.array),
  numberOfHeroes: PropTypes.number,
  currentBreakpoint: PropTypes.string,
  trailerDescription: PropTypes.string,
  ctas: PropTypes.objectOf(PropTypes.object),
  productCollection: PropTypes.instanceOf(PropTypes.object),
  videos: PropTypes.object,
};

export default connect(({ content, breakpoints }) => ({
  currentBreakpoint: R.prop('current', breakpoints),
  images: R.prop('images', content),
  numberOfHeroes: R.path(['custom', 'numberOfHeroes'], content),
  trailerDescription: R.prop('trailerDescription', content),
  videos: R.prop('videos', content),
  productCollection: R.prop('productCollection', content),
  ctas: R.prop('ctas', content),
}))(MadameWeb);
